(function () {
    "use strict";

    angular.module("app").controller("OrganisationSystemsController", OrganisationSystemsController);

    OrganisationSystemsController.$inject = ["controllerDecorator", "cisDossier", "habilDate"];
    function OrganisationSystemsController(controllerDecorator, cisDossier, habilDate) {
        const context = {};

        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation"]);

        vm.GetStyle = getStyle;

        function initialize() {
            context.DossierId = vm.ParseUrl().parameters.dossierid;

            cisDossier.GetCisDossiersForOrganisation(
                context.DossierId,
                r => vm.CisDossiers = r.data,
                vm.ShowError
            );
        }

        initialize();

        function getStyle(cis) {
            if (!cis.ApprovedUntil)
                return "";

            const expiration = habilDate.GetDateOnly(cis.ApprovedUntil);
            const today = habilDate.GetDateOnly(new Date());

            if (expiration.valueOf() < today.valueOf())
                return "overview-expired";

            const oneYearFromNow = habilDate.GetDateOnly(new Date()).setFullYear(today.getFullYear() + 1);
            if (expiration.valueOf() < oneYearFromNow.valueOf())
                return "overview-expiring";

            return "overview-valid";
        }
    }
})();